// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.search_wrapper__Q5Wxy {
  position: relative; /* Làm cha chứa để .search-results căn theo */
  display: flex;
  align-items: flex-start; /* Căn bên trái */
}

.search_search-results__2Dt59 {
  position: absolute; /* Căn chỉnh so với wrapper */
  top: 100%; /* Hiển thị ngay dưới input */
  left: 0;
  right: 0;
  margin-top: 5px; /* Khoảng cách giữa input và kết quả */
  background-color: white;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4); /* Hiệu ứng bóng */
  border-radius: 5px;
  z-index: 1000; /* Đảm bảo hiển thị phía trên */
  max-height: 300px; /* Giới hạn chiều cao */
  overflow-y: auto; /* Cuộn nếu nội dung dài */
  width: 98%; /* Chiều rộng gần bằng input */
}

.search_search__WugML {
  position: relative;
  border-bottom: 1px solid black;
  border-right: 1px solid black;
  padding-left: 8px;
  padding-right: 8rem;
}

.search_clear__ha7lV {
  position: absolute;
  top: 50%;
  right: 0;
  margin-right: 20%;
  transform: translateY(-50%);
  background-color: transparent;
  font-size: 0.7em !important;
  --bs-btn-close-opacity:1;
}
.search_clear__ha7lV:hover {
  opacity: 0.6;
  outline: none !important;
  border-color: transparent !important;
  box-shadow: none !important;
}

.search_search-btn__-3aUb {
  color: white;
}
.search_search-btn__-3aUb:hover {
  opacity: 0.6;
}

.search_result-item__pNjva {
  padding: 5px 5px;
  border-bottom: 1px solid black;
  white-space: nowrap; /* Không cho xuống dòng */
  overflow: hidden; /* Ẩn phần nội dung bị tràn */
  text-overflow: ellipsis; /* Thêm dấu "..." khi nội dung bị tràn */
}`, "",{"version":3,"sources":["webpack://./src/Layout/Search/search.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACI,kBAAA,EAAA,6CAAA;EACA,aAAA;EACA,uBAAA,EAAA,iBAAA;AACJ;;AAGA;EACI,kBAAA,EAAA,6BAAA;EACA,SAAA,EAAA,6BAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA,EAAA,sCAAA;EACA,uBAAA;EACA,0CAAA,EAAA,kBAAA;EACA,kBAAA;EACA,aAAA,EAAA,+BAAA;EACA,iBAAA,EAAA,uBAAA;EACA,gBAAA,EAAA,0BAAA;EACA,UAAA,EAAA,8BAAA;AAAJ;;AAEA;EACI,kBAAA;EACA,8BAAA;EACA,6BAAA;EACA,iBAAA;EACA,mBAAA;AACJ;;AACA;EACI,kBAAA;EACA,QAAA;EACA,QAAA;EACA,iBAAA;EACA,2BAAA;EACA,6BAAA;EACA,2BAAA;EACA,wBAAA;AAEJ;AADI;EACI,YAAA;EACA,wBAAA;EACA,oCAAA;EACA,2BAAA;AAGR;;AAAA;EACI,YAAA;AAGJ;AADI;EACI,YAAA;AAGR;;AACA;EACI,gBAAA;EACA,8BAAA;EACA,mBAAA,EAAA,yBAAA;EACA,gBAAA,EAAA,6BAAA;EACA,uBAAA,EAAA,wCAAA;AAEJ","sourcesContent":["\n.wrapper {\n    position: relative; /* Làm cha chứa để .search-results căn theo */\n    display: flex;\n    align-items: flex-start; /* Căn bên trái */\n\n}\n\n.search-results {\n    position: absolute; /* Căn chỉnh so với wrapper */\n    top: 100%; /* Hiển thị ngay dưới input */\n    left: 0;\n    right: 0;\n    margin-top: 5px; /* Khoảng cách giữa input và kết quả */\n    background-color: white;\n    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.4); /* Hiệu ứng bóng */\n    border-radius: 5px;\n    z-index: 1000; /* Đảm bảo hiển thị phía trên */\n    max-height: 300px; /* Giới hạn chiều cao */\n    overflow-y: auto; /* Cuộn nếu nội dung dài */\n    width: 98%; /* Chiều rộng gần bằng input */\n}\n.search{\n    position: relative;\n    border-bottom: 1px solid black;\n    border-right: 1px solid black;\n    padding-left: 8px;\n    padding-right: 8rem;\n}\n.clear{\n    position: absolute;\n    top: 50%;\n    right: 0;\n    margin-right: 20%;\n    transform: translateY(-50%);\n    background-color: transparent;\n    font-size: 0.7em !important;\n    --bs-btn-close-opacity:1;\n    &:hover{\n        opacity: 0.6;\n        outline: none !important;\n        border-color:transparent !important ;\n        box-shadow: none !important;\n    }\n}\n.search-btn{\n    color: white;\n\n    &:hover{\n        opacity: 0.6;\n    }\n}\n\n.result-item{\n    padding: 5px 5px;\n    border-bottom: 1px solid black;\n    white-space: nowrap; /* Không cho xuống dòng */\n    overflow: hidden; /* Ẩn phần nội dung bị tràn */\n    text-overflow: ellipsis; /* Thêm dấu \"...\" khi nội dung bị tràn */\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `search_wrapper__Q5Wxy`,
	"search-results": `search_search-results__2Dt59`,
	"search": `search_search__WugML`,
	"clear": `search_clear__ha7lV`,
	"search-btn": `search_search-btn__-3aUb`,
	"result-item": `search_result-item__pNjva`
};
export default ___CSS_LOADER_EXPORT___;
